<template>
    <div>
        <NawiCustomData v-if="family == `bilancia nawi`" ref="bilancia nawi" :uom="uom" :o_data="o_data" :c_type="c_type" :r_type="r_type" :selected_reports="selected_reports" :show_info="show_info" :is_multirange="is_multirange"/>
        <NawiMechCustomData v-else-if="family == `bilancia nawi meccanica`" ref="bilancia nawi meccanica" :uom="uom" :o_data="o_data" :c_type="c_type" :r_type="r_type" :selected_reports="selected_reports" :show_info="show_info" :is_multirange="is_multirange"/>
        <AwiCustomData v-else-if="family == `bilancia awi X`" ref="bilancia awi X" :uom="uom" :o_data="o_data" :c_type="c_type" :r_type="r_type" :selected_reports="selected_reports" :show_info="show_info" />
        <AwiCustomData v-else-if="family == `bilancia awi Y`" ref="bilancia awi Y" :uom="uom" :o_data="o_data" :c_type="c_type" :r_type="r_type" :selected_reports="selected_reports" :show_info="show_info" />
        <!-- <DoserCustomData v-else-if="family == `dosatore additivi litri`" ref="dosatore additivi litri" :uom="uom" :o_data="o_data" :c_type="c_type" :selected_reports="selected_reports" :show_info="show_info" /> -->
        <div v-else></div>
    </div>
</template>
<script>
import NawiCustomData from "./NawiCustomData"
import AwiCustomData from "./AwiCustomData"
import NawiMechCustomData from "./NawiMechCustomData"
// import DoserCustomData from "./DoserCustomData"
export default {
    components: { NawiCustomData, AwiCustomData, NawiMechCustomData}, //, DoserCustomData},
    props: ["family", "o_data", "c_type", "r_type", "selected_reports", "show_info", "uom", "is_multirange"],
    data() {
        return {
        }
    },
    methods: {
        getData() {
            console.log('*** CUSTOM', this.family)
            if(!this.$refs[this.family]){ return {} }
            return this.$refs[this.family].getData();
        },
        isValid() {
            if (this.$refs[this.family]) {
                // console.log("$$ test validity custom data", this.family, this.c_type)
                return this.$refs[this.family].isValid(this.c_type)
            }
            return true
        }
    },
}
</script>

<style>
</style>